module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAGFBMVEW+ACbEGTvOQFzRTGflmqn45en//v7///+0cFItAAAAQ0lEQVQY02MoRwUMZPHLnAVN0pH4QQwMDKoIfpkCkM+UDueXMICAO5xfDOabw/mFYL44Tj66enTz0O1Ddw+Ge8n3PwAZ23GxZKWojwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/jp.png
// module id = 309
// module chunks = 0